export default {
    methods: {
        trackEvent(name, subEvent) {
            let eventName = `Autodesk One - ${name}`;
            let params = {}
            if (subEvent) {
                params.subEvent = subEvent
            }

            this.$hhMixpanel.trackEvent(eventName, params);
        },

        trackAutodeskOnePageHit(pageTitle) {
            this.trackEvent(`Page Hit: ${pageTitle}`);
            document.title = `Autodesk One - ${pageTitle}`;
        },

        trackResource(subEvent) {
            this.trackEvent("resource clicked", subEvent);
        }, 

        trackTopStoryClick(subEvent) {
            this.trackEvent("top story clicked", subEvent);
        },

        trackPopularLink(subEvent) {
            this.trackEvent("popular link selected", subEvent);
        },

        trackCalendarEventClick(subEvent) {
            this.trackEvent("calendar event selected", subEvent)
        },

        trackViewAllClick(event) {
            // commonly used in side panel
            this.trackEvent(event);
        },

        trackNewsByInterestStoryClick(subEvent) {
            this.trackEvent("news by interest story clicked", subEvent);
        },

        trackNewsEditInterestsClick() {
            this.trackEvent("edit news interests clicked");
        },

        trackSubscribedToTopic(subscribed, topic) {
            let event = (subscribed) ? "subscribed to topic" : "unsubscribed from topic";
            this.trackEvent(event, topic);
        },

        trackNewsInterestsUpdated(subEvent) {
            this.trackEvent("news interests updated", subEvent);
        },

        trackNewsFeedLoadMoreClicked(event) {
            this.trackEvent(event);
        },

        trackMyContentClicked(subEvent) {
            this.trackEvent("my content link clicked", subEvent);
        },
        
        trackCampaign(subEvent) {
            this.trackEvent("Campaign Banner", subEvent);
        },

        trackOutageAnnouncement(subEvent) {
            this.trackEvent("Outage Announcement", subEvent);
        },

        trackPanelFooterClick(event) {
            this.trackEvent(event);
        },

        trackBackButtonClick() {
            this.trackEvent("Back clicked");
        },

        trackBookmarkClick(subEvent) {
            this.trackEvent("bookmark clicked", subEvent)
        },
        
        trackViewBookmark(subEvent) {
            this.trackEvent("View bookmark clicked", subEvent)
        },

        trackFirstTimeVisitClick() {
            this.trackEvent("First time visit click")
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/HomebaseMixpanelMixin.js